export default __webpack_public_path__ + "static/topFoldSVGReversed-b765429e11655661e1999764c200df19.svg";